import { create } from 'zustand';
import { CardType } from '../application_v2/Appraisal/constants/CardType';

interface PaymentStore {
    address1: string | undefined;
    address2: string | undefined;
    city: string | undefined;
    state: string | undefined;
    zip: string | undefined;
    email: string | undefined;
    name: string | undefined;
    phone: string | undefined;
    cardNumber: string | undefined;
    cardMonthYear: string | undefined;
    cvc: string | undefined;
    cardFocus: 'number' | 'name' | 'expiry' | 'cvc' | undefined;
    cardType: CardType | undefined;

    set_address1: (v: string | undefined) => void;
    set_address2: (v: string | undefined) => void;
    set_city: (v: string | undefined) => void;
    set_state: (v: string | undefined) => void;
    set_zip: (v: string | undefined) => void;
    set_email: (v: string | undefined) => void;
    set_name: (v: string | undefined) => void;
    set_phone: (v: string | undefined) => void;
    set_cardNumber: (v: string | undefined) => void;
    set_cardMonthYear: (v: string | undefined) => void;
    set_cvc: (v: string | undefined) => void;
    set_cardFocus: (v: 'number' | 'name' | 'expiry' | 'cvc' | undefined) => void;
    set_cardType: (v: CardType | undefined) => void;

    reset: () => void;
}

const defaultState = {
    address1: undefined,
    address2: undefined,
    city: undefined,
    state: undefined,
    zip: undefined,
    email: undefined,
    name: undefined,
    phone: undefined,
    cardNumber: undefined,
    cardMonthYear: undefined,
    cvc: undefined,
    cardFocus: undefined,
    cardType: undefined,
};

export const usePaymentStore = create<PaymentStore>((set) => ({
    ...defaultState,

    set_address1: (v) => set({ address1: v }),
    set_address2: (v) => set({ address2: v }),
    set_city: (v) => set({ city: v }),
    set_state: (v) => set({ state: v }),
    set_zip: (v) => set({ zip: v }),
    set_email: (v) => set({ email: v }),
    set_name: (v) => set({ name: v }),
    set_phone: (v) => set({ phone: v }),
    set_cardNumber: (v) => set({ cardNumber: v }),
    set_cardMonthYear: (v) => set({ cardMonthYear: v }),
    set_cvc: (v) => set({ cvc: v }),
    set_cardFocus: (v) => set({ cardFocus: v }),
    set_cardType: (v) => set({ cardType: v }),

    reset: () => set(defaultState),
}));
